<template>
    <div class="new-request__menu">
        <!-- <div class="new-request__menu-button" :class="{ 'selectedTab': request.STATE_request.activeTab === 'search' }" @click="onClickTab('search')">
            <div class="new-menu__head">
                <span class="new-head__text">Busca</span>
                <span style="flex-grow: 1"></span>
                <icon-request-tab-search class="ic-tab"></icon-request-tab-search>
            </div>
            <span class="new-menu__text">{{ this.request.STATE_request.totalSearch }} cadastros<br> encontrados</span>
        </div> -->
        <div class="new-request__menu-button" 
            style="flex-shrink: 0; flex-basis: 1px;" 
            :class="{ 'selectedTab': request.STATE_request.activeTab === 'contact' }" 
            @click="onClickTab('contact')">
            <div class="menu-button__details">
                <icon 
                    :color="(request.STATE_request.activeTab === 'contact') ? 'var(--font-color--10)':'var(--font-color--2)'"
                    name="avatar" 
                    width="32" 
                    height="32" 
                    style="position: relative; left: -3px; margin-right: 5px;" />
                <div class="new-menu__head" style="display: flex; flex-direction: column;">
                    <span class="new-head__text">Contato</span>
                    <span class="tab__shortcut">(ALT + 1)</span>
                </div>
                <div style="margin-left: 20px;flex-grow: 1; display: flex; align-items: flex-end; flex-direction: column;">
                    <span style="font-size: 12px; text-align: right;" v-if="getContactName !== 'Sem nome'">{{ getContactName }}</span>
                    <span style="font-size: 12px; text-align: right;" v-if="getContactPhone !== 'Sem telefone'">{{ getContactPhone }}</span>
                    <span style="font-size: 12px; text-align: right;" v-if="getContactAddress !== 'S/ Logradouro, S/ Número'">{{ getContactAddress }}</span>
                </div>
            </div>
        </div>
        <div class="new-request__menu-button" 
            style="flex-shrink: 0; flex-basis: 1px;" 
            :class="{ 'selectedTab': request.STATE_request.activeTab === 'order' }" 
            @click="onClickTab('order')">
            <div class="menu-button__details">
                <icon name="receipt" width="32" height="32" style="position: relative; left: -3px; margin-right: 5px;" />
                <div class="new-menu__head" style="display: flex; flex-direction: column;">
                    <span class="new-head__text">Pedido</span>
                    <span class="tab__shortcut">(ALT + 2)</span>
                </div>
                <div style="margin-left: 20px;flex-grow: 1; display: flex; align-items: flex-end; flex-direction: column;">
                    <span style="font-size: 12px; text-align: right;">{{ getQuantityAndAmount.quantity }}</span>
                    <span style="font-size: 12px; text-align: right;">{{ getQuantityAndAmount.amount }}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: ['request'],
    data() {
        return {
        } 
    },
    computed: {
        getContactName() {
            const contactName = _.has(this.request, 'requestContact.contact') && this.request.requestContact.contact ? this.request.requestContact.contact.name : null
            return contactName ? this.utils.getShortString(this.utils.toTitleizeString(contactName), 18, '...') : 'Sem nome'
        },
        getContactPhone() {
            let contactPhoneDefault = this.request.requestContact.contact ? this.request.requestContact.contact.contactPhones.filter(phone => phone.isDefault)[0] : null
            const contactPhone = contactPhoneDefault ? contactPhoneDefault.number : null
            return contactPhone  ? (this.utils.formatPhone(contactPhone) ? this.utils.formatPhone(contactPhone) : 'Tel. invalido') : 'Sem telefone'
        },
        getContactAddress() {
            let contactAddressDefault = this.request.requestContact.contact ? this.request.requestContact.contact.contactAddresses.filter(contactAddresses => contactAddresses.isDefault)[0] : null
            if(contactAddressDefault) {
                let address = this.utils.getShortString(contactAddressDefault.address.name ? this.utils.toTitleizeString(contactAddressDefault.address.name) : 'S/ Logradouro', 25, '...')
                let contactAddressNumber = this.utils.getShortString(contactAddressDefault.number ? contactAddressDefault.number : 'S/ Número', 15, '...')
                return `${address}, ${contactAddressNumber}`
            }
            return 'Endereço de entrega'
        },
        getQuantityAndAmount(){
            let quantity = 0
            let amount = 0
            if(this.request.requestOrder && this.request.requestOrder.requestOrderProducts.length){
                this.request.requestOrder.requestOrderProducts.forEach(value => {
                    if(Number.isInteger(value.productId)) { 
                        quantity += value.quantity
                        amount += (value.unitPrice - value.unitDiscount) * value.quantity
                    }
                })
                this.request.requestOrder.requestOrderServices.forEach(value => {
                    if(Number.isInteger(value.serviceId)) {
                        quantity += 1
                        amount += (value.price - value.discount)
                    }
                })
            }

            quantity = quantity !== 1 ? `${quantity} pedidos` : `1 pedido`
            return { quantity, amount: `${this.utils.formatMoney(amount, '2', 'R$ ', '.', ',')}` }
        }
    },
    methods: {
        onClickTab(tabName) {
            const vm = this

            if(tabName === 'contact') {
                this.$bus.$emit('activeTabContact')
            }

            vm.request.STATE_request.$update({
                where: vm.request.STATE_request.id,
                data: { activeTab: tabName }
            })
        }
    }
}
</script>

<style lang="scss">
    .new-request__menu {
        height: 70px;
        /*background: #23272B;*/
        display: flex;
        flex-direction: row;
        align-items: center;
        background: #161A1D;
        .new-head__text {
            margin-bottom: 3px;
            font-size: 18px;
            font-weight: 800;
            color: #C3C5C6;
            line-height: 100%;
        }
        .tab__shortcut {
            font-size: 9px; 
            font-weight: 600;
        }
    }
    .new-request__menu-button{
        display: flex;
        flex-direction: column;
        background: #23272B;
        height: 70px;
        border-top: 1px solid #161A1D ;
        border-bottom: 1px solid #161A1D ;
        padding: 6px 10px 6px 10px;
        flex-grow: 1;
        cursor: pointer;
        margin-right: 1px;
        .menu-button__details {
            padding: 0 5px 0 0;
            display: flex;
            height: 100%;
            flex-direction: row;
            align-items: center;
        }
        &:last-child {
            margin-right: 0;
        }
    }
    .new-menu__head{
        display: flex;
        flex-direction: row;

    }
    .new-menu__text{
        font-size: 12px;
        color: #73777B;
        font-family: Arial, Helvetica, sans-serif;
        opacity: .6;
    }
    .new-head__text{
        font-size: 18px;
        color: #73777B;
        margin-bottom: 3px;
        font-family: Arial, Helvetica, sans-serif;
        font-weight: 600;

    }
    .ic-tab {
        opacity: .4;
    }
    .new-request__menu-button:hover, .selectedTab {
        background: linear-gradient(202.57deg, #49DFEA -10.02%, #594BC8 91.15%);
        .menu-button__details .app-icon path {
            fill: white
        }
        .new-menu__text{
            color: white;
        }
        .new-head__text{
            color: white;   
        }
        .ic-tab {
            opacity: 1;
        }
        span {
            color: var(--font-color--10)
        }
        .tab__shortcut {
            color: var(--font-color--8)
        }
    }
</style>

